import React from "react";
import Hero from "./Hero";
import Brokerage from "./Brokerage";
import Charges from "./Charges";

function PricingPage() {
  return (
    <>
      <Hero />
      <Brokerage />
      <Charges/>
    </>
  );
}

export default PricingPage;
